import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, tap } from 'rxjs/operators'

import { SURVEY_ACTION, USER_SURVEY_ACTION } from '../../constants/actions'
import apiService from '../../services/api'
import { wrapUserAccessToken } from '../../util/auth.helpers'
import { logger } from '../../util/log.helpers'
import {
  buildCreateUserSurveyData,
  buildUpdateUserSurveyData,
  formatUserSurveysToObject,
  formatUserSurveyToObject
} from '../../util/survey.helpers'

const handleSubmitUserSurvey = (action$) =>
  action$.pipe(
    ofType(SURVEY_ACTION.ON_SUBMIT_USER_SURVEY),
    mergeMap(({ payload: { surveyId, questionId, liked } }) =>
      wrapUserAccessToken((accessToken) =>
        apiService
          .submitUserSurvey(
            buildCreateUserSurveyData(surveyId, {
              [questionId]: { liked }
            }),
            accessToken
          )
          .pipe(
            tap((data) => logger(data)),
            map(({ response }) => ({
              type: SURVEY_ACTION.ON_SUBMIT_USER_SURVEY_SUCCESS,
              payload: formatUserSurveyToObject(response.data)
            })),
            catchError((err) =>
              of({
                type: SURVEY_ACTION.ON_SUBMIT_USER_SURVEY_FAILED,
                payload: err
              })
            )
          )
      )
    )
  )

const handleUpdateUserSurvey = (action$, state$) =>
  action$.pipe(
    ofType(SURVEY_ACTION.ON_UPDATE_USER_SURVEY),
    mergeMap(({ payload: { surveyId, id, questionId, liked } }) =>
      wrapUserAccessToken((accessToken) =>
        apiService
          .updateUserSurvey(
            id,
            buildUpdateUserSurveyData(
              { surveyId, response: { [questionId]: { liked } } },
              state$
            ),
            accessToken
          )
          .pipe(
            tap((data) => logger(data)),
            map(({ response }) => ({
              type: SURVEY_ACTION.ON_UPDATE_USER_SURVEY_SUCCESS,
              payload: formatUserSurveyToObject(response.data)
            })),
            catchError((err) =>
              of({
                type: SURVEY_ACTION.ON_UPDATE_USER_SURVEY_FAILED,
                payload: err
              })
            )
          )
      )
    )
  )

const handleGetSubmissions = (action$) =>
  action$.pipe(
    ofType(SURVEY_ACTION.ON_GET_USER_SURVEYS),
    mergeMap(() =>
      wrapUserAccessToken((accessToken) =>
        apiService.getUserSurveys(accessToken).pipe(
          tap((data) => logger(data)),
          map(({ response }) => ({
            type: SURVEY_ACTION.ON_GET_USER_SURVEYS_SUCCESS,
            payload: formatUserSurveysToObject(response.data)
          })),
          catchError((err) =>
            of({
              type: SURVEY_ACTION.ON_GET_USER_SURVEYS_FAILED,
              payload: err
            })
          )
        )
      )
    )
  )

const handleGetSurveyResponseAnalytics = (action$) =>
  action$.pipe(
    ofType(SURVEY_ACTION.ON_GET_USER_SURVEYS_SUCCESS),
    mergeMap(() =>
      wrapUserAccessToken((accessToken) =>
        apiService.getUserSurveyAnalytics(accessToken).pipe(
          tap((data) => logger(data)),
          map(({ response }) => ({
            type: USER_SURVEY_ACTION.ON_GET_SURVEY_ANALYTICS_SUCCESS,
            payload: response.data
          })),
          catchError((err) =>
            of({
              type: USER_SURVEY_ACTION.ON_GET_SURVEY_ANALYTICS_FAILED,
              payload: err
            })
          )
        )
      )
    )
  )

export const surveyEpic = combineEpics(
  handleSubmitUserSurvey,
  handleUpdateUserSurvey,
  handleGetSubmissions,
  handleGetSurveyResponseAnalytics
)
